module.exports = __webpack_public_path__ + "static/media/x.cb428c88.svg";